import withDatosSesion from "../../hoc/withTrabajadores/withDatosSesion";
import VistaDatosSesion from "../../view/components/RegistroUsuarios/DatosSesion/VistaDatosSesion";

export default withDatosSesion(VistaDatosSesion);